'use client'

import { ComponentProps } from 'react'

import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'

import OfferMessageWithConversationContext from './OfferMessageWithConversationContext'
import InquiryOfferMessage from './InquiryOfferMessage'

type Props = ComponentProps<typeof OfferMessageWithConversationContext>

const OfferMessage = (props: Props) => {
  const isWebMessagingSvcFSEnabled = useFeatureSwitch('web_messaging_svc')

  const OfferMessageComponent = isWebMessagingSvcFSEnabled
    ? InquiryOfferMessage
    : OfferMessageWithConversationContext

  return <OfferMessageComponent {...props} />
}

export default OfferMessage
